import { benchmarkAttributes } from './benchmark_attributes';
import { combineReducers } from '@reduxjs/toolkit';
import { companiesSettings } from './company_settings';
import { unmappedAttributeValues } from './unmapped_values';
import { benchmarkQuestions } from './benchmark_questions';

const entities = combineReducers({
  attributes: benchmarkAttributes,
  questions: benchmarkQuestions,
  companiesSettings,
  unmappedAttributeValues,
});

export { entities };
